import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class FormsService {
    private _$submitting: { [key: string]: BehaviorSubject<boolean> } = {};

    constructor() {}

    public submitting$(guid: string): Observable<boolean> {
        if (!this._$submitting[guid]) {
            this._$submitting[guid] = new BehaviorSubject(false);
        }
        return this._$submitting[guid].asObservable();
    }

    public setSubmitting(isSubmitting: boolean, guid: string) {
        if (!this._$submitting[guid]) {
            this._$submitting[guid] = new BehaviorSubject(false);
        }
        this._$submitting[guid].next(isSubmitting);
    }
}
